module.exports = __webpack_public_path__ + "static/ClickUP-84ac4d16b0d418fc835b4ec584b3daef.svg";